/**
 * 検査情報
 */
export class InspectionInfo {
    /** 検査項目コード */
    inspectionCode = ""
    /** 検査項目名 */
    inspectionName = ""
    /** 検査項目名（略称） */
    inspectionShortName = ""
    /* 検査分類コード */
    classificationCode =  ""
    /** その他項目フラグ 0: 検査項目 1: その他の項目 ※報告書が不要かどうかの判断 */
    otherItem = false
    /** 検査日数 */
    days = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<InspectionInfo>) {
        Object.assign(this, init)
    }
}
